//
import type { RouteRecordRaw } from 'vue-router';
import BasicLayout from '../../layouts/BasicLayout.vue';
import ErrorLayout from './layouts/ErrorLayout.vue';
import { RouteNames } from '@/router/routeNames';

const e: RouteRecordRaw = {
  path: '/error',
  component: BasicLayout,
  children: [
    {
      name: RouteNames.ERROR,
      path: '',
      redirect: () => {
        return { name: RouteNames.ERROR_LAYOUT };
      },
    },
    {
      name: RouteNames.ERROR_LAYOUT,
      path: '',
      component: ErrorLayout,
      meta: {
        pageTitle: 'Landing.Error',
      },
    },
  ],
};
export default e;
